import api from './axios';

class ServiceCompendio {
  async combobox(id = '', text = '', filterType, page = 1) {
    const { data } = await api.get(`/compendio/agrotoxicos/combobox?id=${id || ''}&text=${encodeURIComponent(text)}&page=${page}`);
    return data;
  }

  async findPesticideById(id) {
    const { data } = await api.get(`/compendio/agrotoxicos/${id}`);
    return data;
  }

  async findDiagnosysIdCulture(id, idCultura, uf = "") {
    const { data } = await api.get(`/compendio/indicacoes?idAgrotoxico=${id}&idCultura=${idCultura}&state=${uf}`);
    return data;
  }

  async findPesticideByCommonName(commonName) {
    const { data } = await api.get(`/compendio/agrotoxicos?nomeComum=${commonName}`);
    return data;
  }

  async findApplicationsByCrop(pesticideId, uf = "") {
    const { data } = await api.get(`/compendio/agrotoxicos-culturas/aplicacao-por-cultura/${pesticideId}?state=${uf}`);
    return data;
  }

  async findCultures(text = "", page = 1) {
    const { data } = await api.get(
      `/compendio/culturas?q=${encodeURIComponent(text)}&page=${page}`
    );
    return data;
  }

  async findCultureById(id) {
    const { data } = await api.get(`/compendio/culturas/${id}`);
    return data;
  }

  async findUsageIndications(pesticideId) {
    const { data } = await api.get(`/compendio/indicacoes?idAgrotoxico=${pesticideId}`);
    return data;
  }

  async findAllEmbalagensByIdAgrotoxico(idAgrotoxico) {
    const { data } = await api.get("/compendio/agrotoxicos/embalagens/" + idAgrotoxico);

    return data.map(item => {
      return {
        id: item.id,
        capacidade: item.capacidade,
        unidade: item.unidade,
        descricao: `${item.capacidade} ${item.unidade} - ${item.tipoEmbalagem} - ${item.material} - ${item.caracteristicas} - ${item.acondicionamento} - ${item.lavabilidade}`,
        codMt: item?.codMt || '',
        codSicca: item?.codSicca || '',
        codSc: item?.codSc || ''
      }
    });
  }

  async findApplicationMethods(pesticideId) {
    const { data } = await api.get(`/compendio/agrotoxicos/modalidades-aplicacoes/${pesticideId}`);
    return data;
  }

  async findInfoAdditionals(pesticideId) {
    const { data } = await api.get(`/compendio/agrotoxicos/informacoes-adicionais/${pesticideId}`);
    return data;
  }

  async findUpdates(page = 1) {
    const { data } = await api.get(`/compendio/updates-report?page=${page}`);
    return data;
  }

  async findAllProblems(idCategoriaProblema) {
    const { data } = await api.get(`/compendio/problemas`, {
      params: { idCategoriaProblema }
    });
    return data;
  }

  async findAgrotoxicsByCultureAndProblem(idCultura, idProblema) {
    const { data } = await api.get(`/compendio/culturas/controle-agrotoxicos/${idCultura}/${idProblema}`);
    return data;
  }

  async findAgrotoxicDetails(idCultura, idProblema, idAgrotoxico) {
    const { data } = await api.get(
      `/compendio/culturas/controle/${idCultura}/${idProblema}/${idAgrotoxico}`
    );
    return data;
  }
}
export default new ServiceCompendio();